import axios from 'axios';
import {useState,useEffect} from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [token, setToken] = useState('');
    const [ttr, setTtr] = useState('');
    const [status, setStatus] = useState(true);

const nav= useNavigate()
     const location = useLocation();
    // Extract email and token from URL query parameters
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const email = params.get('email') || '';
      const token = params.get('token') || '';
      const ttr = params.get('ttr') || '';
      if (ttr > 0) {
        const expirationTime = ttr;
        if (isNaN(expirationTime) || expirationTime < Date.now()) {
          setError('This link has expired');
          return;
        }
      }


const checkotp = async() => {
    const params = new URLSearchParams(location.search);
   //await axios.post('https://lightningpresort-3c0bfe3acad3.herokuapp.com/user/checkotp', {
    await axios.post('http://localhost:5009/user/checkotp', {
        email,
        token,
      })
      .then(res => {
        console.log(res.data)
        if(res.data.status !== 200){
            nav('/',{ replace: true })
        }else{
            setEmail( params.get('email'))
            setToken( params.get('token'))
        }
    })
      .catch(err => console.log(err))
}


checkotp()
    }, [location.search]);

    const validateForm = () => {
      if (!password || !confirmPassword) {
        setError('Both password fields are required');
        return false;
      }
      if (password !== confirmPassword) {
        setError('Passwords do not match');
        return false;
      }
      if (password.length < 8) {
        setError('Password must be at least 8 characters long');
        return false;
      }
      return true;
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      setMessage('');
      setError('');
      setIsLoading(true);

      if (!validateForm()) {
        setIsLoading(false);
        return;
      }

      if (!email || !token) {
        setError('Invalid or missing reset link');
        setIsLoading(false);
        return;
      }

      try {
       // const response = await axios.post('https://lightningpresort-3c0bfe3acad3.herokuapp.com/user/reset-password', {
             const response = await axios.post('http://localhost:5009/user/reset-password', {
          email,
          token,
          password
        });
        if(response?.data.status === 200){toast.success('Password Successfully Changed'); nav('/', {replace:true})}
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to reset password');
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">Set New Password</h2>
          <p className="text-center text-gray-600 mb-6">
            Enter your new password below.
          </p>
          {message && <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">{message}</div>}
          {error && <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">{error}</div>}
          <div className="space-y-4">
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                New Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter new password"
              />
            </div>
            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                Confirm Password
              </label>
              <input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="mt-1 w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Confirm new password"
              />
            </div>
            <button
              onClick={handleSubmit}
              disabled={isLoading}
              className={`w-full py-2 px-4 bg-blue-600 text-white rounded hover:bg-blue-700 transition duration-200 ${
                isLoading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {isLoading ? 'Resetting...' : 'Reset Password'}
            </button>
          </div>
          <p className="mt-4 text-center text-sm text-gray-600">
            Back to <a href="/login" className="text-blue-600 hover:underline">Login</a>
          </p>
        </div>
      </div>
    );
}
    export default ResetPassword